import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";
import Popup01 from "../../pages/popup/Popup01";
import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HLSVideo from '../../libs/hlsVideo';

// ==================== 상수 정의 ====================

// 헤더 텍스트
const HEADER_TEXT = {
  title: {
    ko: '스케치업 스타일 모델링',
    en: 'SketchUp-Style Modeling'
  },
  subTitle: {
    ko: '면을 그리고 당기기만 하면 당신의 아이디어를 바로 3D로 구현할 수 있습니다.',
    en: 'Simply draw and drag—turn your ideas into 3D instantly.'
  }
};

const CONTENT_ITEMS = [
  {
    title: { ko: '푸시-풀 모델링', en: 'Push-Pull Modeling' },
    description: {
      ko: '면을 선택해 밀고 당기기만 하면 쉽게 3D 도형을 생성할 수 있으며, 기존 도형을 간단한 조작만으로 잘라내거나 변형하는 것도 가능합니다.',
      en: 'Select, push, and pull—create 3D shapes effortlessly.  Easily modify or trim existing shapes with simple adjustments.'
    },
    video: "/m3u8/sk_01.m3u8",
    thum: require("../../assets/thumnails/sk_01_thum.webp"),
    reverse: false
  },
  {
    title: { ko: '직관적인 그리기 방식 지원', en: 'Drawing-Based Modeling' },
    description: {
      ko: '선을 자유롭게 그리기만 하면 즉시 2D 도형이 생성되며, 이를 활용해 손쉽게 모델링을 시작할 수 있습니다. 직관적인 방식으로 도형을 만들고 수정할 수 있어 빠르고 효율적인 작업이 가능합니다.',
      en: 'Simply draw lines freely to instantly generate 2D shapes and  start modeling with ease. This direct approach allows quick shape  creation and modification, enabling a faster and more efficient workflow.'
    },
    video: "/m3u8/sk_02.m3u8",
    thum: require("../../assets/thumnails/sk_02_thum.webp"),
    reverse: true
  },
  {
    title: { ko: '곡선 도형도 간편하게 생성', en: 'Create Curved Shapes' },
    description: {
      ko: 'Polyline, Rectangle뿐만 아니라 Arc, Disk 등의 다양한 곡선 도형도 손쉽게 생성하고 편집할 수 있습니다. 이를 통해 직선뿐만 아니라 곡선 형태의 모델링도 더욱 유연하고 정밀하게 작업할 수 있습니다.',
      en: 'Create and edit a variety of curved shapes with ease, including arcs,  disks, polylines, and rectangles. Go beyond straight lines—achieve  more fluid and precise modeling with curved geometry.'
    },
    video: "/m3u8/sk_03.m3u8",
    thum: require("../../assets/thumnails/sk_03_thum.webp"),
    reverse: false
  },
  {
    title: { ko: '홀이 포함된 폴리곤 지원', en: 'Create Holed Polygons' },
    description: {
      ko: '내부에 구멍(홀)이 있는 폴리곤도 손쉽게 생성할 수 있으며, 필요에 따라 크기나 형태를 자유롭게 변경 하거나 수정할 수 있습니다. 이를 통해 더욱 정밀한 모델링 작업이 가능하며, 다양한 디자인 요소를 효율적으로 구현할 수 있습니다.',
      en: 'Easily generate polygons with internal holes and freely adjust  their size and shape as needed. Achieve more precise modeling  and efficiently integrate complex design elements.'
    },
    thum: require("../../assets/thumnails/sk_04_thum.webp"),
    video: "/m3u8/sk_04.m3u8",
    reverse: true
  }
];

// 배너 텍스트
const BANNER_TEXT = {
  title: {
    ko: '그리고, 밀고, 당겨서 완성!',
    en: 'Draw, Push, Pull, Done!'
  },
  inquiryButton: {
    ko: '문의 하기',
    en: 'Contact Us'
  },
  startButton: {
    ko: '무료로 써보기',
    en: 'Try for Free'
  }
};

// ==================== 컴포넌트 ====================
export default function Modeling() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lang = useSelector(state => state.langReducer.lang);
  const [supBtnHover, setSupBtnHover] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="main_back">
        <div className="main_part padding">
          {/* 헤더 섹션 */}
          <div className="header_page_title_box">
            <p className="title">
              {lang === 0 ? HEADER_TEXT.title.ko : HEADER_TEXT.title.en}
            </p>
            <span className="sub_title">
              {lang === 0 ? HEADER_TEXT.subTitle.ko : HEADER_TEXT.subTitle.en}
            </span>
          </div>

          {/* 콘텐츠 섹션 */}
          <div className="header_page_content_box">
            {CONTENT_ITEMS.map((item, index) => {
              return (
                <div className={`content ${item.reverse ? 'end' : ''}`} key={index}>
                  {item.reverse ? (
                    <>
                      <div className="title_box">
                        <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.description.ko : item.description.en}
                        </span>
                      </div>
                      <div className="img_box">
                        <HLSVideo
                            width="100%"
                            height="100%"
                            autoPlay
                            muted
                            loop
                            playsInline
                            poster={item.thum}
                            src={item.video}
                        >
                            소개 영상입니다.
                        </HLSVideo>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="img_box">
                        <HLSVideo
                            width="100%"
                            height="100%"
                            autoPlay
                            muted
                            loop
                            playsInline
                            poster={item.thum}
                            src={item.video}
                        >
                            소개 영상입니다.
                        </HLSVideo>
                      </div>
                      <div className="title_box">
                        <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.description.ko : item.description.en}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* 배너 섹션 */}
        <div className="page_start_banner">
          <div className="content">
            <p className="title">
              {lang === 0 ? BANNER_TEXT.title.ko : BANNER_TEXT.title.en}
            </p>
            <div className="btn_box">
              <button 
                type="button" 
                className={`start ${lang === 1 ? 'eng' : ''}`}
                style={{width: 220,}}
                onClick={() => {
                  navigate(routes.Price);
              }}
              >
                {lang === 0 ? BANNER_TEXT.startButton.ko : BANNER_TEXT.startButton.en}
              </button>              
              <button 
                type="button" 
                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                style={{width: 220,}}
                onClick={() => navigate(routes.Inquiry)}
              >
                {lang === 0 ? BANNER_TEXT.inquiryButton.ko : BANNER_TEXT.inquiryButton.en}
              </button>

            </div>
          </div>
        </div>
      </div>

      <ToastContainer 
        position="bottom-center"
        transition={Slide}
        limit={1}
        closeButton={false}
        autoClose={1000}
        style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
        hideProgressBar
      />
    </>
  );
}